import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"
import Img from "gatsby-image"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.org/docs/use-static-query/
 *
 *
 * https://takumon.com/simple-gatsby-image-wrapper
 */

const ReaderBlockBgImage = ({ fileName }) => {
  const data = useStaticQuery(graphql`
    query {
      images: allFile {
        edges {
          node {
            relativePath
            name
            childImageSharp {
              sizes(maxWidth: 2075, quality: 90) {
                ...GatsbyImageSharpSizes
              }
            }
          }
        }
      }
    }
  `)

  const image = data.images.edges.find(n => {
    return n.node.relativePath.includes(fileName)
  })

  if (!image) {
    return null
  }

  const imageSizes = image.node.childImageSharp.sizes

  return (
    <Img
      style={{
        width: "100%",
        minWidth: "600px",
      }}
      sizes={imageSizes}
    />
  )
}
ReaderBlockBgImage.propTypes = {
  fileName: PropTypes.string.isRequired,
}
export default ReaderBlockBgImage
